// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"daa0ed24","294":"edb01afb","325":"4c98ebff","848":"80ff417e","943":"585f79bd"}[chunkId] + ".chunk.js";
};